import { Playlist } from '@kinomap-dev/ng-ui-lib/core';

export function convertPlaylistToPlaylistContentTableItem(playlist: Playlist): any {
  return {
    title: { name: playlist.name, thumbnail: playlist.images['512x512'] },
    duration: playlist.duration,
    sessions: 9999999,
    comments: playlist.comments_count,
    likes: playlist.likes_count,
    labels: ['test', 'my test label', 'is mock'],
  };
}
